import { CONTACT } from '../../constants';
import Button from '../../components/ui/Button/Button';
import './CtaBand.css';

export default function CtaBand() {
  return (
    <section className="cta-band">
      <div className="cta-band__left">
        <h2 className="cta-band__title">
          Ready to invest in<br />
          <em>Lagos real estate?</em>
        </h2>
        <p className="cta-band__body">
          Speak with the NimbleCasa development team today. We'll walk you through
          available units, pricing, payment plans, and title status — no obligation.
        </p>
      </div>

      <div className="cta-band__right">
        <Button href="/#contact" variant="light">Get in Touch</Button>
        <Button href={CONTACT.phoneHref} variant="ghost-white">
          Call {CONTACT.phone}
        </Button>
      </div>
    </section>
  );
}
